import { defineStore } from "pinia";
import { computed, ref } from "vue";
import { HeaderButton } from "./headerButton";
import { BuybackHeaderAction } from "./buybackHeaderAction";
import { HeaderAction } from "./headerAction";

const useHeaderButtonStore = defineStore("headerButton", () => {
  const headerButton = ref(new HeaderButton());

  const secondaryHeaderButton = ref(new HeaderButton());

  const isAnyBuybackActionActive = computed(() => headerButton.value.isAnyActionActive());

  const initHeaderAction = (headerAction: HeaderAction) => {
    headerButton.value.setHeaderAction(headerAction);
  };

  const initSecondaryHeaderAction = (headerAction: HeaderAction) => {
    secondaryHeaderButton.value.setHeaderAction(headerAction);
  };

  const initBuybackActions = (actions: BuybackHeaderAction[]) => {
    headerButton.value.setBuybackActions(actions);
  };

  const activateBuybackActions = (actionKeys: string[]) => {
    headerButton.value.activateBuybackActions(actionKeys);
  };

  const updateBuybackAction = (actionKey: string, newData: Partial<BuybackHeaderAction>) => {
    headerButton.value.updateAction(actionKey, newData);
  };

  const resetHeaderActions = () => {
    headerButton.value = new HeaderButton();
    secondaryHeaderButton.value = new HeaderButton();
  };

  const setActionBtnLoadingState = () => {
    headerButton.value.setIsButtonLoading(true);
  };

  const resetActionBtnLoadingState = () => {
    headerButton.value.setIsButtonLoading(false);
  };

  return {
    headerButton,
    secondaryHeaderButton,
    isAnyBuybackActionActive,
    initHeaderAction,
    initSecondaryHeaderAction,
    initBuybackActions,
    activateBuybackActions,
    updateBuybackAction,
    resetHeaderActions,
    setActionBtnLoadingState,
    resetActionBtnLoadingState,
  };
});

export default useHeaderButtonStore;
